import * as Sentry from "@sentry/react";

/**
 * Professional Logger Utility (Phase 4: Observability)
 * Wraps Sentry and standard console logging with enhanced features.
 */
export const logger = {
  info: (message: string, data?: any) => {
    console.log(`[INFO] ${message}`, data || '');
    Sentry.addBreadcrumb({
      category: "log",
      message,
      level: "info",
      data,
    });
  },

  warn: (message: string, data?: any) => {
    console.warn(`[WARN] ${message}`, data || '');
    Sentry.captureMessage(message, "warning");
  },

  error: (message: string, error?: any, data?: any) => {
    console.error(`[ERROR] ${message}`, error || '', data || '');
    
    Sentry.withScope((scope) => {
      if (data) {
        scope.setExtras(data);
      }
      if (error instanceof Error) {
        Sentry.captureException(error);
      } else {
        Sentry.captureException(new Error(message));
      }
    });
  },

  debug: (message: string, data?: any) => {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[DEBUG] ${message}`, data || '');
      Sentry.addBreadcrumb({
        category: "debug",
        message,
        level: "debug",
        data,
      });
    }
  },

  // Nuevos métodos para logging específico
  user: (action: string, userId?: string, data?: any) => {
    const message = `User action: ${action}`;
    console.log(`[USER] ${message}`, { userId, ...data });
    Sentry.addBreadcrumb({
      category: "user",
      message,
      level: "info",
      data: { userId, action, ...data }
    });
  },

  api: (method: string, url: string, status?: number, duration?: number) => {
    const message = `API ${method} ${url}`;
    console.log(`[API] ${message}`, { status, duration });
    Sentry.addBreadcrumb({
      category: "api",
      message,
      level: "info",
      data: { method, url, status, duration }
    });
  },

  performance: (operation: string, duration: number, data?: any) => {
    const message = `Performance: ${operation}`;
    console.log(`[PERF] ${message} (${duration}ms)`, data);
    Sentry.addBreadcrumb({
      category: "performance",
      message,
      level: "info",
      data: { operation, duration, ...data }
    });
  },

  setUserId: (id: string | null) => {
    if (id) {
      Sentry.setUser({ id });
    } else {
      Sentry.setUser(null);
    }
  }
};
